/*
 * @Descripttion: 商家中心接口
 * @version:
 * @Author: loong
 * @Date: 2022-09-22 16:26:31
 * @LastEditors: loong
 * @LastEditTime: 2022-10-08 11:45:11
 */
import * as config from "./config";
// 商家审核动态分页列表
export const supplierPage = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/supplier/page';


export const getShopId = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/solution/shop/get/';
